import React from 'react';
import { Maintenance } from '@havenengineering/module-shared-owners-ui/dist/components/Maintenance';

const MaintenancePage = () => <Maintenance />;

export const getStaticProps = () => ({
  props: {
    pageTitle: 'Maintenance',
    availableForGuests: true,
  },
  revalidate: 60 * 30,
});

export default MaintenancePage;
